export default __webpack_public_path__ + "static/turismo-icon-two-2a11546bf6deb962b49d4461c48ec1b7.svg";